import { createAction } from '@reduxjs/toolkit'

import { Lang } from 'language/translator'
import { TPatchEconomyResponse } from 'types/GlobalCustomer'

export interface TUpdateSelfResponse {
  attributes: {
    email: string
    first_name: string
    last_name: string
    language?: Lang
  }
  id: string
}

// tryUpdateSelf
export const updateSelf = createAction('update_self')
export const updateSelfSuccess = createAction<TUpdateSelfResponse>(
  'update_self_success'
)
export const updateSelfFailed = createAction('update_self_failed')

// tryUpdateEconomy
export const updateEconomy = createAction('update_economy_settings')
export const updateEconomySuccess = createAction<TPatchEconomyResponse>(
  'update_economy_settings_success'
)
export const updateEconomyFailed = createAction(
  'update_economy_settings_failed'
)
